import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/main.global'
import './utils/plugin'
import './assets/iconfont/iconfont.css'
import './styles/index.styl'
import './styles/vant.styl'
import { Component } from 'vue-property-decorator'
import preview from './components/preview/index'
/* debugger时使用 */
// import VConsole from 'vconsole';
// new VConsole();
Vue.config.productionTip = false
import { Col, Row } from 'vant';
// 组件内增加路由钩子
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate'
])
Vue.use(Col);
Vue.use(Row);
// 文件预览组件
Vue.use(preview)
// 根据环境判断打包是否需要oem
if (process.env.VUE_APP_OEM) {
  store.dispatch('getIsOem')
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
